import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { AppConfig } from 'src/app/app.config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConsentAdapter, Consent } from './consent.model';
import { Brand, BrandAdapter } from './consent/brand.model';

@Injectable({
  providedIn: 'root'
})
export class ConsentService {

  consentList: any[];

  constructor(private consentAdapter: ConsentAdapter, private brandAdapter: BrandAdapter, private http: HttpClient, private authService: AuthService, private appConfig: AppConfig, private appPrivate: AppConfig) { }

  getConsents(): Observable<Consent[]> {
    let headers = this.getJwtToken();
    return this.http.get(`${this.appConfig.getAppConfig().authUrl}/consents`, { headers }).pipe(
      //adapt each item in the raw data array
      map((data: Consent[]) => data.map(item => this.consentAdapter.adapt(item)))
    )
  }

  setConsentList(consentList: Consent[]) {
    this.consentList = consentList;
  }
  getConsentList(): Consent[] {
    return this.consentList;
  }

  getBrands(): Observable<Brand[]> {
    let headers = this.getJwtToken();
    return this.http.get(`${this.appConfig.getAppConfig().authUrl}/brands`, { headers }).pipe(
      //adapt each item in the raw data array
      map((data: Brand[]) => data.map(item => this.brandAdapter.adapt(item)))
    )
  }

  updateConsentText(consentText: string, key: string): Observable<any> {
    const headers = this.getJwtToken();
    const id = key;
    const payload = { consentText: consentText };
    return this.http.patch(`${this.appConfig.getAppConfig().authUrl}/consents/${id}`, payload, { headers });
  }

  getJwtToken(): HttpHeaders {
    let token = localStorage.getItem('token');
    return new HttpHeaders({ 'Authorization': `Bearer ${token}` });
  }

  saveConsent(consent: Consent): Observable<any> {
    const headers = this.getJwtToken();
    return this.http.post(`${this.appConfig.getAppConfig().authUrl}/consents/`, consent, { headers });
  }

  deleteConsent(consent: Consent) {
    const headers = this.getJwtToken();
    const key = consent.key;
    return this.http.delete(`${this.appConfig.getAppConfig().authUrl}/consents/${key}`,{ headers });
  }
}
